import { lazy } from 'react';
import { LinkTo } from 'shared/constants/linkTo';

const CoursePage = lazy(() => import('shared/pages/myCourses/CoursePage/CoursePage'));
const CoursesListPage = lazy(() => import('shared/pages/myCourses/CoursesList/CoursesListPage'));

const GroupsPage = lazy(() => import('shared/pages/myCourses/GroupsPage'));
const homeworkCheckPage = lazy(() => import('shared/pages/HomeworkCheck/HomeworkCheckPage'));
const HomeworkPage = lazy(() => import('shared/pages/myCourses/Homeworks/HomeworkPage'));
const LMSGroupPage = lazy(() => import('shared/pages/groups/LMSGroupPage'));
const SchedulePage = lazy(() => import('shared/pages/myCourses/Schedule/SchedulePage'));
const ExploreHseContextsExternal = lazy(() => import('shared/pages/exploreHseContextsNew/exploreHseContextsExternal'));
const HomeworkEstimatePage = lazy(() => import('shared/pages/HomeworkCheck/HomeworkEstimatePage'));
const StudentGradesPage = lazy(() => import('shared/pages/HomeworkCheck/StudentGradesPage'));

const LMSRoutes = [
    { path: LinkTo.checkHomework, exact: true, isPrivate: true, component: homeworkCheckPage },
    { path: LinkTo.myCourses, exact: true, isPrivate: true, component: CoursesListPage },
    { path: LinkTo.myCoursesHomework, exact: true, isPrivate: true, component: HomeworkPage },
    { path: LinkTo.myCoursesGrades, exact: true, isPrivate: true, component: StudentGradesPage },
    { path: LinkTo.myCoursesGroups, exact: true, isPrivate: true, component: GroupsPage },
    { path: LinkTo.myCoursesSchedule, exact: true, isPrivate: true, component: SchedulePage },
    { path: LinkTo.coursePage, exact: true, isPrivate: true, component: CoursePage },
    { path: '/courses/:teamName', exact: true, component: ExploreHseContextsExternal },
    { path: '/courses/profile/groups/:teamName/:groupId', exact: true, component: LMSGroupPage },
    { path: '/estimate/:moduleId', exact: true, isPrivate: true, component: HomeworkEstimatePage },
   
    
];

export default LMSRoutes;import { lazy } from 'react';
import { LinkTo } from 'shared/constants/linkTo';

const CoursePage = lazy(() => import('shared/pages/myCourses/CoursePage/CoursePage'));
const CoursesListPage = lazy(() => import('shared/pages/myCourses/CoursesList/CoursesListPage'));

const GroupsPage = lazy(() => import('shared/pages/myCourses/GroupsPage'));
const homeworkCheckPage = lazy(() => import('shared/pages/HomeworkCheck/HomeworkCheckPage'));
const HomeworkPage = lazy(() => import('shared/pages/myCourses/Homeworks/HomeworkPage'));
const LMSGroupPage = lazy(() => import('shared/pages/groups/LMSGroupPage'));
const SchedulePage = lazy(() => import('shared/pages/myCourses/Schedule/SchedulePage'));
const ExploreHseContextsExternal = lazy(() => import('shared/pages/exploreHseContextsNew/exploreHseContextsExternal'));
const HomeworkEstimatePage = lazy(() => import('shared/pages/HomeworkCheck/HomeworkEstimatePage'));
const StudentGradesPage = lazy(() => import('shared/pages/HomeworkCheck/StudentGradesPage'));

const LMSRoutes = [
    { path: LinkTo.checkHomework, exact: true, isPrivate: true, component: homeworkCheckPage },
    { path: LinkTo.myCourses, exact: true, isPrivate: true, component: CoursesListPage },
    { path: LinkTo.myCoursesHomework, exact: true, isPrivate: true, component: HomeworkPage },
    { path: LinkTo.myCoursesGrades, exact: true, isPrivate: true, component: StudentGradesPage },
    { path: LinkTo.myCoursesGroups, exact: true, isPrivate: true, component: GroupsPage },
    { path: LinkTo.myCoursesSchedule, exact: true, isPrivate: true, component: SchedulePage },
    { path: LinkTo.coursePage, exact: true, isPrivate: true, component: CoursePage },
    { path: '/courses/:teamName', exact: true, component: ExploreHseContextsExternal },
    { path: '/courses/profile/groups/:teamName/:groupId', exact: true, component: LMSGroupPage },
    { path: '/estimate/:moduleId', exact: true, isPrivate: true, component: HomeworkEstimatePage },
   
    
];

export default LMSRoutes;